import React, { Component } from 'react'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { withRouter, NavLink } from "react-router-dom"
//import { NavLink} from "react-router-dom";
import axios from 'axios'
import { connectNode } from '../../../utils/global'
import { escapeHtml } from '../../../utils/textFunctions'
import '../../../styles/assets/css/admin/form3.css'
import { loadLocationWithMessage } from '../../../actions/location'

import WarningIcon from '@material-ui/icons/Warning'

import TextField from '@material-ui/core/TextField'
import Button from '@material-ui/core/Button'
import FormControl from '@material-ui/core/FormControl'
import Select from '@material-ui/core/Select'
import MenuItem from '@material-ui/core/MenuItem'
import ReactHtmlParser from 'react-html-parser'

class ResourceDetail extends Component {
  constructor() {
      super()
      this.state = {
          status: false,
          status_submit: true,
          message: '',
          name: '',
          url: '',
          free: 0,
          cost: '',
          description: '',
          category: 0,
          categoryList: [],
          dataList: [],
          editMode: false,
      }
  }

  componentDidMount() {
    this.getData()
  }

  getData = () => {
    axios({
      method: 'post',
      url: connectNode + 'admin/worksheets/get_resource_w_edit',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json;charset=UTF-8'
      },
      data: { sg_id: this.props.match.params.sg_id }
    })
    .then((result) => {
      this.setState({
        uid: this.props.authReducer.uid,
        name: result['data'].name,
        url: result['data'].url,
        free: result['data'].free,
        cost: result['data'].cost,
        description: result['data'].description,
      })
    })
  }

  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    })
  }

  handleChange2 = (e, name) => {
    this.setState({
      [name]: e,
    })
  }

  handleChange7 = (e) => {
    var val = 0
    if (e.target.checked) {
      val = 1
    }
    this.setState({
      [e.target.name]: val,
    })
  }

  handleSubmit = (e) => {
    e.preventDefault()
    if(this.state.url == '' || this.state.category == 0 || this.state.name.trim() == '') {
      this.setState({
        msg_status: false,
        message: 'Please fill all information',
      })
    } else {
      axios({
        method: 'post',
        url: connectNode + 'admin/worksheets/edit_self_guide',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json;charset=UTF-8'
        },
        data: {
          uid: this.props.authReducer.uid,
          sg_id: this.props.match.params.sg_id,
          name: this.state.name,
          url: this.state.url,
          category: this.state.category,
          free: this.state.free,
          cost: this.state.cost,
          description: this.state.description,
        }
      })
      .then((result) => {
        if(result['data'] == this.props.match.params.sg_id) {
          this.props.onLoadLocation('/admin/worksheets/self_guide_list', 'Update self-guided program completed!')
          this.props.history.push('/admin/worksheets/self_guide_list')
        } else {
          this.setState({
            msg_status: false,
            message: 'Something went wrong. Please try again.',
          })
        }
        window.scrollTo(0, 0)
      })
    }
  }

  render() {
    //console.log(this.state)
    return (
      <div className="admin_log_outcome box_border4">
        <div className="row">
          <div className="small-12 columns headerPage1">
            Resource: {this.state.name}
          </div>
        </div>
        <div className="row">
          <div className="small-12 columns ">
            <div className="box_border5">
              <form id="new_self_stigma" onSubmit={this.handleSubmit}>
                <div className="row">
                  <div className="small-12 columns box_inner2 top_space1">
                    <div className="row">
                      <div className="small-12 medium-2 columns bold_txt3">
                        <div className="no_top_space1">Name:</div>
                      </div>
                      <div className="small-12 medium-8 columns no_padding_left_float_left">
                      {this.state.name}
                      </div>
                    </div>
                    <div className="row top_space1">
                      <div className="small-12 medium-2 columns bold_txt3">
                        <div className="no_top_space1">Link:</div>
                      </div>
                      <div className="small-12 medium-8 columns no_padding_left_float_left">
                      <a href={this.state.url} target="_blank" >{this.state.url}</a>
                      </div>
                    </div>
                    {this.state.free != 1 &&
                    <div className="row top_space1">
                      <div className="small-12 medium-2 columns bold_txt3">
                        <div className="no_top_space1">Cost:</div>
                      </div>
                      <div className="small-12 medium-8 columns no_padding_left_float_left">
                      {this.state.cost}
                      </div>
                    </div>}
                    <div className="row top_space1 sg_description">
                      <div className="small-12 medium-2 columns bold_txt3">
                        <div className="no_top_space1">Description:</div>
                      </div>
                      <div className="small-12 medium-8 columns no_padding_left_float_left">
                      {ReactHtmlParser(this.state.description)}
                      </div>
                    </div>
                    <div className="row">
                      <div className="small-12 medium-2 columns">
                        <p>&nbsp;</p>
                        <p>&nbsp;</p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row top_space1">
                  <div className="small-12 columns text_align_right">
                  <a onClick={() => this.props.history.goBack()} className="go_back">Go Back</a>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  //console.log('AddPatient STATE: ', state)
  return state
}

const mapDispatchToProps = (dispatch) => ({
  onLoadPages(response) {
    //console.log('AddPatient mapDispatchToProps')
    dispatch({
      type: 'LOAD_USER_AUTH',
      payload: response,
    })
  },
  onLoadLocation(route, msg) {
    dispatch(loadLocationWithMessage(route, msg))
  },
})

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(ResourceDetail)
